// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Dg","heading":"Eg"};